import { IHttpClient } from '~/packages/core';
import { IFeedbackData } from './types';

export class FeedbackAdapter {
    protected readonly httpClient: IHttpClient;

    constructor(httpClient: IHttpClient) {
        this.httpClient = httpClient;
    }

    sendFeedback(objectId: string, feedbackData: IFeedbackData) {
        const data = {
            ...feedbackData,
            feedback_object_id: objectId
        };

        return this.httpClient.request({
            method: 'post',
            url: `/api/v2/feedback`,
            data
        });
    }
}
